
import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import ProductBar from "../Components/ProductBar";
import { useState } from "react";
import Product from "../models/Product";

interface FurnitureProps{
  includeDetails: boolean;
}

function FurniturePage(props: FurnitureProps) {
  const [productsList] = useState<Product[]>([
    { name: 'Visitor Chair', price: 100, description: '', category: 'Furniture', currency: 'PKR', imgPath: '/chair_black.jpg' },
    { name: 'Revolving Office Chair', price: 50, description: "", category: 'Furniture', currency: 'PKR', imgPath: '/office-chair_black.jpg' },
    { name: 'Standing Office Stool', price: 100, description: 'Solid Wooden Stool with Black Base', category: 'Furniture', currency: 'PKR', imgPath: '/stool_black.jpg' },
    { name: 'Standing Office Stool', price: 100, description: 'Solid Wooden Stool with Brown Base', category: 'Furniture', currency: 'PKR', imgPath: '/stool_brown.jpg' },
  ]);

  return (
    <Box>
        <Typography fontFamily={'Georgia'} color={'#432308'} fontSize={40} sx={{marginBottom: "40px", backgroundColor:'#fce5cc', width: '100%'}} variant="h2">furniture</Typography>
        <ProductBar products={productsList} extended={props.includeDetails}/>   
    </Box>
  );
}

export default FurniturePage;